export default __webpack_public_path__ + "c59d4f9a436d42525a0f4934bca5894f.svg";